import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './i18n';
import './styles/globals.css';

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import SppbAutofill from './components/SppbAutofill';
import Pricing from './components/Pricing';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Download from './components/Download';
import Footer from './components/Footer';
import Legal from './components/Legal';

const HomePage: React.FC = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <Features />
      <SppbAutofill />
      <Pricing />
      <About />
      <Testimonials />
      <Contact />
      <Download />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Navigate to="/ezschool/ezrph" replace />} />
          <Route path="/ezschool/ezrph" element={<HomePage />} />
          <Route path="/privacy" element={<Legal type="privacy" />} />
          <Route path="/terms" element={<Legal type="terms" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
